import React from 'react';

export default function MundVturb() {
  return (
    <svg
      width={88}
      height={56}
      viewBox="0 0 88 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_vturb_8847)">
        <rect
          x={3.50488}
          y={13.8579}
          width={40}
          height={40}
          rx={10}
          transform="rotate(-15 3.50488 13.8579)"
          fill="url(#paint0_linear_vturb_8847)"
        />
        {/* MESMA MARCA DA MUNDPAY USADA EM MundMemberkit, DENTRO DO QUADRADO */}
        <g clipPath="url(#clip1_vturb_8847)">
          <path
            d="M26.0782 15.3202L25.2322 16.5812C25.1136 16.7583 24.8855 16.8194 24.6942 16.7253L23.3277 16.0524C23.2183 15.9983 23.0886 15.9925 22.9776 16.039C22.2987 16.321 21.6254 16.6682 20.9644 17.0789C17.4743 19.2485 15.2675 23.0547 15.1143 27.1758C14.8342 34.8436 20.5852 40.395 27.1835 40.829C28.543 40.9176 29.9398 40.7911 31.3277 40.4192C32.7157 40.0473 33.9886 39.4584 35.1217 38.702C39.5809 35.7222 41.8726 30.0987 40.4028 24.6132C38.7155 18.3162 32.6423 14.343 26.374 15.1313C26.2525 15.1472 26.1425 15.2148 26.0732 15.3191L26.0782 15.3202ZM18.1565 31.7824L18.1581 31.7795L21.9767 30.7564C22.1772 30.8671 22.294 30.9311 22.4923 31.0424C23.3437 33.6622 24.4822 35.8833 25.7497 37.5145C25.9995 37.8361 25.7041 38.2918 25.3113 38.1897C22.1249 37.3395 19.4058 35.0104 18.1527 31.7858L18.1565 31.7824ZM30.803 38.16C30.7771 38.1693 30.7527 38.1758 30.7284 38.1824C30.704 38.1889 30.6797 38.1954 30.6525 38.2003C29.2126 38.467 26.475 35.7235 24.736 30.4817C24.6595 30.2496 24.7941 29.9991 25.0287 29.9362L31.5413 28.1911C31.776 28.1283 32.0177 28.278 32.0676 28.5172C33.1824 33.9262 32.1811 37.6716 30.803 38.16ZM35.4211 35.4808C35.1348 35.7672 34.6505 35.518 34.7039 35.1153C34.9992 32.9675 34.8453 30.3301 34.1989 27.4838C34.1983 27.4816 34.2005 27.481 34.2005 27.481L33.7102 25.651C33.6494 25.4242 33.4162 25.2889 33.1904 25.3494L18.0246 29.4131C17.7701 29.4813 17.5199 29.3004 17.4919 29.0363C17.1486 25.7894 18.3299 22.6274 20.5518 20.4091C20.8402 20.1221 21.323 20.374 21.2679 20.7796C21.0627 22.2717 21.0753 24.0009 21.3167 25.8761C21.3491 26.1296 21.6028 26.2975 21.8486 26.2317L23.2675 25.8515C23.4712 25.7969 23.6027 25.5972 23.5773 25.3871C23.0534 21.0591 23.9675 18.1569 25.1698 17.7299L25.3182 17.6901C26.573 17.4588 28.8178 19.5145 30.526 23.5253C30.609 23.7199 30.8205 23.8276 31.0264 23.7725L32.4431 23.3929C32.6889 23.327 32.8253 23.0569 32.7259 22.819C32.0025 21.0753 31.1465 19.5721 30.2244 18.3798C29.9745 18.0582 30.2682 17.5959 30.6593 17.7008C33.8379 18.5483 36.5496 20.8674 37.807 24.0814C37.8118 24.0992 37.8188 24.1164 37.8235 24.1342L38.4104 26.3244C38.4152 26.3421 38.4199 26.3599 38.4225 26.3783C38.9405 29.7904 37.7495 33.1553 35.4205 35.4785L35.4211 35.4808Z"
            fill="url(#paint1_linear_vturb_8847)"
          />
        </g>
      </g>
      {/* À direita do quadrado: logo VTurb (igual Memberkit tem texto à direita) */}
      <path
        d="M41.7163 18.9599C43.1658 13.5502 43.8906 10.8454 45.497 9.06127C46.9101 7.4919 48.7837 6.41017 50.8494 5.9711C53.1977 5.47195 55.9025 6.19671 61.3122 7.64623L69.0396 9.71678C74.4493 11.1663 77.1542 11.8911 78.9383 13.4975C80.5077 14.9106 81.5894 16.7842 82.0285 18.8498C82.5276 21.1982 81.8029 23.903 80.3533 29.3127L78.2828 37.0401C76.8333 42.4498 76.1085 45.1546 74.5021 46.9388C73.089 48.5081 71.2154 49.5899 69.1497 50.0289C66.8014 50.5281 64.0966 49.8033 58.6869 48.3538L50.9595 46.2833C45.5498 44.8337 42.8449 44.109 41.0608 42.5025C39.4914 41.0895 38.4097 39.2159 37.9706 37.1502C37.4715 34.8019 38.1962 32.097 39.6458 26.6873L41.7163 18.9599Z"
        fill="#0F111C"
      />
      {/* removido triângulo azul da ponta direita */}
      {/* Logo VTurb centralizada dentro do \"quadrado\" da direita (mais um pouco maior) */}
      <g transform="translate(60 30) scale(0.5) translate(-18 -20)">
        <path
          d="M32.5759 12.974C30.6234 11.8981 28.715 10.743 26.7882 9.6211C24.6309 8.36655 22.4754 7.10828 20.318 5.85188C17.8423 4.41123 15.3464 3.00375 12.8963 1.5189C11.2605 0.527769 9.55331 -0.0691186 7.62469 0.00641349C6.56706 0.046943 6.53774 0.0358906 6.53591 1.13019C6.53408 6.09136 6.53412 11.0526 6.53412 16.0137C6.53412 21.0357 6.53042 26.0595 6.53591 31.0815C6.53774 32.3232 7.01538 32.8777 8.21752 33.1043C8.84517 33.2222 9.38676 32.9772 9.91193 32.7008C10.3822 32.454 10.8232 32.1519 11.2825 31.8847C15.6502 29.3424 20.0198 26.8038 24.3893 24.2652C25.8934 23.3919 27.4177 22.5519 28.8999 21.6437C29.9263 21.0154 30.1606 19.6264 29.4579 18.7421C29.1834 18.3976 28.8101 18.1802 28.4369 17.9647C25.7471 16.4024 23.0554 14.8421 20.3638 13.2835C17.7783 11.7858 15.1909 10.2972 12.6109 8.79214C12.2303 8.56917 12.051 8.59317 12.0528 9.07952C12.0583 10.0061 12.0583 10.9328 12.0491 11.8576C12.0454 12.1819 12.1772 12.3992 12.4554 12.5558C13.469 13.1306 14.481 13.7128 15.4892 14.2986C18.4974 16.0432 21.5056 17.786 24.5119 19.5379C25.028 19.8382 25.017 20.0372 24.4954 20.343C22.0234 21.7892 19.5495 23.2335 17.0774 24.6779C14.8506 25.9785 12.6255 27.281 10.4005 28.5816C9.92655 28.8579 9.79117 28.7897 9.75269 28.2537C9.74359 28.1302 9.74724 28.0068 9.74724 27.8834C9.74724 20.308 9.74538 12.7327 9.74538 5.15734C9.74538 4.93074 9.74172 4.70415 9.76186 4.4794C9.82593 3.74434 9.93938 3.67801 10.5597 4.0391C13.2477 5.60317 15.9283 7.17462 18.6163 8.73683C22.7736 11.1539 26.9383 13.5543 31.0864 15.9861C32.0947 16.5774 32.7662 17.4875 33.0626 18.6297C33.6628 20.9417 32.7626 22.9774 30.6729 24.1583C29.533 24.8031 28.4076 25.4719 27.2768 26.1314C21.7123 29.383 16.1497 32.6363 10.5834 35.8843C9.39407 36.5788 8.10407 36.7759 6.79943 36.3761C4.68235 35.7277 3.4692 33.9757 3.4692 31.73C3.46737 24.0312 3.47651 16.3324 3.46004 8.63365C3.45821 7.58545 3.53689 6.58141 4.09681 5.66581C4.21941 5.46684 4.23038 5.23656 4.23038 5.00812C4.23038 3.93777 4.23587 2.86743 4.22672 1.79708C4.22489 1.60365 4.30176 1.35126 4.06022 1.25178C3.87359 1.1744 3.69976 1.31257 3.56069 1.42495C2.5177 2.26686 1.61559 3.22667 0.976986 4.43334C0.219444 5.86661 0.0565912 7.42517 0.0620807 8.98552C0.0858683 16.7857 -0.153815 24.5876 0.17555 32.384C0.320105 35.8124 2.47194 38.3971 5.56249 39.4766C6.36577 39.7566 7.22579 40.068 8.06566 39.987C9.54593 39.8451 10.9897 39.5061 12.3126 38.7139C14.9622 37.1278 17.6538 35.6116 20.3253 34.0604C24.2704 31.7687 28.2118 29.4714 32.1568 27.1796C33.5201 26.3874 34.7094 25.4387 35.5128 24.0201C37.6975 20.1643 36.3983 15.0815 32.5759 12.974Z"
          fill="url(#paint_vturb_symbol_8847)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_vturb_8847"
          x1={23.5049}
          y1={13.8579}
          x2={23.5049}
          y2={53.8579}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#29282C" />
          <stop offset={1} stopColor="#100F11" />
        </linearGradient>
        {/* MESMO GRADIENTE DA MARCA MUNDPAY EM MundMemberkit */}
        <linearGradient
          id="paint1_linear_vturb_8847"
          x1={10.6936}
          y1={13.8569}
          x2={35.8057}
          y2={35.4541}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset={1} stopColor="white" stopOpacity={0.65} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_vturb_8847"
          x1={73.94}
          y1={19.44}
          x2={69.95}
          y2={22.25}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01E3FD" />
          <stop offset={1} stopColor="#0060EA" />
        </linearGradient>
        <linearGradient
          id="paint_vturb_symbol_8847"
          x1="0"
          y1="0.5"
          x2="1"
          y2="0.5"
          gradientUnits="objectBoundingBox"
        >
          <stop offset="0" stopColor="#F04E1F" />
          <stop offset="0.27" stopColor="#E84438" />
          <stop offset="0.65" stopColor="#FB0047" />
          <stop offset="1" stopColor="#E90058" />
        </linearGradient>
        <clipPath id="clip0_vturb_8847">
          <rect
            x={3.50488}
            y={13.8579}
            width={40}
            height={40}
            rx={10}
            transform="rotate(-15 3.50488 13.8579)"
            fill="white"
          />
        </clipPath>
        {/* MESMA ÁREA INTERNA (30x30) DO QUADRADO USADA EM MundMemberkit */}
        <clipPath id="clip1_vturb_8847">
          <rect
            width={30}
            height={30}
            fill="white"
            transform="translate(9.62891 17.3936) rotate(-15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
